document.addEventListener("DOMContentLoaded", () => {
  const cards = document.querySelectorAll("[data-aos='zoom-in']");
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) entry.target.classList.add("aos-animate");
    });
  }, { threshold: 0.3 });

  cards.forEach(card => observer.observe(card));
});
